<template>
  <el-container class="relative table-page no-shrink-mobile">
    <aside class="filters-bar el-aside d-flex column sidebar-links">
      <router-link :to="'/class/'+$route.params.id"><span>Students</span></router-link>
      <router-link :to="'/assessment/'+$route.params.id"><span>Assessment</span></router-link>
      <div class="disabled-wrap">
        <router-link :to="'/analytics/'+$route.params.id" class="d-flex"><span>Analytics</span>
          <div class="premium"><img src="/static/premium.svg" alt=""><span>premium</span></div>
        </router-link>
      </div>
      <div :class="{'disabled-wrap': isLoading || (currentClass.demos && !currentClass.demos.length)}">
        <router-link :to="'/tours/'+$route.params.id"><span>Tours</span></router-link>
      </div>
    </aside>
    <div class="el-main" v-loading="isLoading">
      <div class="headings">
        <h2 style="margin-top: 0; text-align: center">Tours assigned to "{{ currentClass.name }}"</h2>
        <div v-if="currentClass.demos && currentClass.demos.length">
          <div class="d-flex justify-between align-end">
            <h3 style="margin: 0">Tours</h3>
            <el-button type="success" @click="$router.push('/library')">ASSIGN TOUR</el-button>
          </div>

          <el-table
              class="students-table"
              :border="true"
              :data="currentClass.demos"
              style="width: 100%; margin-top: 20px;">
            <el-table-column
                :resizable="false"
                prop="name"
                column-key="Name"
                label="Name">
              <template slot-scope="scope">
                <b class="hidden-sm-and-up">Name:</b> {{ scope.row.title }}
              </template>
            </el-table-column>
            <el-table-column
                width="120"
                :resizable="false"
                align="center"
                label="Actions">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleRemove(scope.$index, scope.row)">Unassign
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>

      </div>

    </div>
  </el-container>
</template>

<script>
  export default {
    name: 'myClasses',
    data() {
      return {
        isLoading: true,
        currentClass: {
          name: ''
        },
      }
    },
    mounted: function () {
      this.axios.get(this.$store.state.API_URL + 'class/' + this.$route.params.id)
        .then((res) => {
          this.currentClass = res.data;
          this.isLoading = false
        });
    },
    methods: {
      handleRemove(index, row) {
        this.axios.post(this.$store.state.API_URL + "class/unassign/" + this.currentClass._id, {demo_id: row._id}).then((res) => {
          this.$message({
            message: 'Tour "' + row.title + '" unassigned.',
            type: 'success',
            showClose: true,
          });
          this.currentClass.demos.splice(index, 1);
          if (!this.currentClass.demos.length) {
            this.$router.push("/my-classes");
          }
        });
      },
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/Tours.vue